export const language = {
  en: {
    Confirm: "Confirm",
    Edit: "Edit",
    Save: "Save",
    Cancel: "Cancel",
    "Please Entry": "Please Entry",

    "Company Name": "Company Name",
    "Chinese Name of The Company": "Chinese Name of The Company",
    "English Name of The Company": "English Name of The Company",
    "Unified Tax ID": "Unified Tax ID",
    "Please Enter Numbers&English Letter":
      "Please Enter Numbers&English Letter",
    "Please Enter The Number": "Please Enter The Number",
    "Please Enter The Correct Mailbox Format":
      "Please Enter The Correct Mailbox Format",
    "Company Country": "Company Country",
    China: "China",
    Thailand: "Thailand",
    Australia: "Australia",
    "United States": "United States",
    "United Kingdom": "United Kingdom",
    France: "France",
    "Company Address": "Company Address",
    Province: "Province",
    City: "City",
    District: "District",
    "Bank Name": "Bank Name",
    "Bank Account": "Bank Account",
    "Landline Number": "Landline Number",
    "Tel Number": "Tel Number",
    Email: "Email",
    "Seller Center": "Seller Center",
    "Quotation Management": "Quotation Management",
    "Inquiry Quotation": "Inquiry Quotation",
    "Bidding Quotation": "Bidding Quotation",
    "Sourcing Reply": "Sourcing Reply",
    "Bidding Management": "Bidding Management",
    "Procurement Plan Management": "Procurement Plan Management",
    "Plan List": "Plan List",
    'Import and Export Documents': 'Import and Export Documents',
    'Document Management': 'Document Management',
    "Supplier Price Center": "Supplier Price Center",
    "Supplier Poultry Price Report": "Supplier Poultry Price Report",
    "Supplier Pork Price Report": "Supplier Pork Price Report",
    'Product Recommendation List': 'Product Recommendation List',
    'List of imported goods': 'List of imported goods',
  },
  zh: {
    'Import and Export Documents': '进出口单据服务',
    'Document Management': '单据管理',
    Confirm: "确认",
    Edit: "编辑",
    Save: "保存",
    Cancel: "取消",
    "Please Entry": "请输入",

    "Company Name": "公司名称",
    "Chinese Name of The Company": "公司中文名称",
    "English Name of The Company": "公司英文名称",
    "Unified Tax ID": "统一社会信用代码",
    "Please Enter Numbers&English Letter": "请输入数字+英文",
    "Please Enter The Number": "请输入数字",
    "Please Enter The Correct Mailbox Format": "请输入正确的邮箱格式",
    "Company Country": "公司所在国家",
    China: "中国",
    Thailand: "泰国",
    Australia: "澳大利亚",
    "United States": "美国",
    "United Kingdom": "英国",
    France: "法国",
    "Company Address": "公司地址",
    Province: "省",
    City: "市",
    District: "区",
    "Bank Name": "银行名称",
    "Bank Account": "银行账号",
    "Landline Number": "座机号",
    "Tel Number": "手机号",
    Email: "邮箱",
    "Seller Center": "供应商中心",
    "Quotation Management": "报价管理",
    "Inquiry Quotation": "询价回复",
    "Bidding Quotation": "竞价回复",
    "Sourcing Reply": "寻源回复",
    "Bidding Management": "招投标管理",
    "Procurement Plan Management": "采购计划管理",
    "Plan List": "计划单列表",
    "Supplier Price Center": "价格中心",
    "Supplier Pork Price Report": "猪肉价格提报",
    "Supplier Poultry Price Report": "禽肉价格提报",
    'Product Recommendation List': '商品推荐清单',
    'List of imported goods': '进口商品清单',
  },
};
